<template>
  <v-chip
    v-if="status"
    outlined
    small
    class="font-weight-regular ml-2"
    color="secondarytext"
  >
    <v-badge dot inline :color="statusColor">{{ status }}</v-badge>
  </v-chip>
</template>

<script>
export default {
  name: "MemberStatusChip",
  props: {
    status: {
      type: String,
      default: ""
    }
  },
  computed: {
    statusColor() {
      switch (this.status) {
        case "Added":
          return "info";
        case "Active":
          return "success";
        case "Inactive":
          return "error";
        default:
          return "grey";
      }
    }
  }
};
</script>
